import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getFeaturesByPlan: {
    method: 'GET',
    url: `${configs.baseUrl}/api/features-by-plan/{plan}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getFeaturesByPlan = (plan) => {
  return resource.getFeaturesByPlan(plan)
}

export default {
  initResource,
  getFeaturesByPlan,
}
